// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"ba4483f1","507":"49c750dc","540":"b6ff824c","553":"a0d17d43","623":"7d900160","668":"c44d1fd3","767":"8dbf8996","803":"f5a4cbd6","813":"ad5cb40f","826":"57602e7b","917":"65f7319b","984":"0885009b","988":"030235fb"}[chunkId] + ".chunk.js";
};